<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {

  },
  beforeCreate() {
      if(this.$store.state.privateKey === '' && localStorage.getItem("stada_private_key") !== null)  {
         this.axios.post('/backend/web/validation', {'privateKey' : localStorage.getItem("stada_private_key")}).then((response) => {
            var vm = this;
            vm.error = false;
            if( response.data.privateKey !== undefined) {
                vm.$store.state.privateKey = response.data.privateKey;
                localStorage.setItem("stada_private_key", response.data.privateKey);
                vm.$router.push({ path: "/StartQuiz" });
            } else {
                vm.error = true;
            }
        });
        this.$store.state.privateKey = localStorage.getItem("stada_private_key");
      } 
  }

}
</script>

<style lang="scss">
@import 'src/assets/sass/main.scss';

</style>
